import "./styles.css";
import React from "react";

import Anlyzer from "../../maintenance-form/analyzer";
import DoAnalyzer from "../../maintenance-form/do-analyzer";
import GasDetector from "../../maintenance-form/gas-detector";
import MetalDetector from "../../maintenance-form/metal-detector";
import MetalDetectorTon from "../../maintenance-form/metal-detector-ton";

// import Modal from "../../component/insane-table-no-http/component/action-modal-form";
import ModalAction from "../../component/insane-table-no-http/component/action-modal-form-action";

//////////// REDUX | STORE | SERVICE /////////////
import { useDispatch } from "react-redux";
import { HttpRequest } from "../../service/HttpRequest";
import { showLoad, dismissLoad } from "../../store/slice/loading";

function MaintenanceWorkorderView(props) {
  const PARAM = props.location.state;
  const [MtResult, setMtResult] = React.useState(null);

  // console.log(PARAM);

  const dispatch = useDispatch();

  const ActionWorkOrder = {
    mapTable: [
      {
        displayName: "MT Result No",
        attName: "mtresultno",
        type: "text",
        form: {
          validate: true,
          element: "input",
        },
      },
      {
        displayName: "Remark",
        attName: "approve_remark",
        type: "text",
        form: {
          validate: true,
          element: "input",
        },
      },
    ],
    api: {
      approve: {
        enable: true,
        url: "/admin/mt/mtresult/approve",
        dataReq: {
          mtresultno: "",
          remark: "",
        },
      },
      reject: {
        enable: true,
        url: "/admin/mt/mtresult/reject",
        dataReq: {
          mtresultno: "",
          remark: "",
        },
      },
    },
    action: [
      {
        name: "Approve",
        mode: "modal-form-action", /// page, modal, form
        option: {
          type: "approve",
        },
      },
      {
        name: "Reject",
        mode: "modal-form-action", /// page, modal, form
        option: {
          type: "reject",
        },
      },
    ],
  };

  function getFullFormCodeName(formcode) {
    let result = "";
    if (MtResult && MtResult.form.length > 0) {
      result = MtResult.form[0].formname;
    } else {
      switch (formcode) {
        case "AZ":
          result = "Analyzer";
          break;
        case "DOAZ":
          result = "DO Analyzer";
          break;
        case "GASD":
          result = "Gas Detector";
          break;
        case "MD":
          result = "Metal Detector";
          break;
        case "MDTON":
          result = "Metal Detector 1 Ton";
          break;

        default:
          break;
      }
    }
    return result;
  }

  function twoDigit(n) {
    let number = parseInt(n);
    if (number <= 9) {
      return "0" + number;
    } else {
      return "" + number;
    }
  }

  function ConvertDate(dateString, type = "datetime") {
    // console.log(dateString);
    if (dateString) {
      let date = new Date(dateString);
      if (type === "datetime") {
        return (
          date.getFullYear() +
          "-" +
          twoDigit(date.getMonth() + 1) +
          "-" +
          twoDigit(date.getDate()) +
          " " +
          twoDigit(date.getHours()) +
          ":" +
          twoDigit(date.getMinutes()) +
          ":" +
          twoDigit(date.getSeconds())
        );
      }
      if (type === "date") {
        return (
          date.getFullYear() +
          "-" +
          twoDigit(date.getMonth() + 1) +
          "-" +
          twoDigit(date.getDate())
        );
      }
      if (type === "time") {
        return (
          twoDigit(date.getHours()) +
          ":" +
          twoDigit(date.getMinutes()) +
          ":" +
          twoDigit(date.getSeconds())
        );
      }
    } else {
      return "";
    }
  }

  async function onRequest(state = "") {
    dispatch(showLoad());

    await HttpRequest("/admin/mt/mtresult/get", {
      mtresultno: PARAM.mtresultno,
      workorderno: PARAM.workorderno,
      attachsequence: true,
    }).then((data) => {
      if (data.result === "OK") {
        console.log("workorder sequence : ", data);
        if (data.mtresults.length > 0) {
          setMtResult(data.mtresults[0]);
        }
      }
    });

    dispatch(dismissLoad());
    // console.log("dataReq --> ", dataReq);
  }
  
  const onEditSequence = React.useCallback(async (e) => { 

    console.log("workorder view");
    console.log(e);

    
    dispatch(showLoad());

    let body = {...MtResult};

    let index_sequence = body.sequence.findIndex((seq) => seq.sequenceno === e.sequenceno);
    
    console.log(index_sequence);

    if (index_sequence >= 0) {
      body.sequence[index_sequence] = e;
    }
    
    console.log(body);

    await HttpRequest("/admin/mt/mtresult/update", body).then((data) => {
      console.log("workorder change sequence : ", data);
      if (data.result === "OK") {
        onRequest();
      }else{
        alert("Edit sequence error. " + (data.errormessage ? data.errormessage : ''));
      }
    });

    dispatch(dismissLoad());

    // dispatch(showLoad()); 
    // onRequest(); 
  }, [MtResult]);

  React.useEffect(() => {
    const controller = new AbortController();

    onRequest();

    return () => {
      controller.abort();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="content">
      {MtResult ? (
        <div className="content-page content-workorder-view">
          <div className="menu">
            <div className="toppic">
              <span style={{ flexGrow: 1 }}>
                {" "}
                {PARAM.attachequipment.tagid}{" "}
              </span>
              {ActionWorkOrder.action.map((action, action_index) => {
                return (
                  <ModalAction
                    key={action_index}
                    type={action.option.type}
                    api={ActionWorkOrder.api}
                    data={PARAM}
                    titleButton={action.name}
                    mapTable={ActionWorkOrder.mapTable}
                  ></ModalAction>
                );
              })}
            </div>
            <div className="detail-container">
              <div className="detail-row">
                <div className="name">Form Code : </div>
                <div className="value">
                  ( {MtResult.formcode} ) -{" "}
                  {getFullFormCodeName(MtResult.formcode)}
                </div>
              </div>
              <div className="detail-row">
                <div className="name">MT Result No : </div>
                <div className="value">{MtResult.mtresultno}</div>
              </div>
              <div className="detail-row">
                <div className="name">Work Order No : </div>
                <div className="value">{MtResult.workorderno}</div>
              </div>
              <div className="detail-row">
                <div className="name">User : </div>
                <div className="value">{MtResult.userid}</div>
              </div>
              <div className="detail-row">
                <div className="name">Calibration Date : </div>
                <div className="value">
                  {ConvertDate(MtResult.calibration_date)}
                </div>
              </div>
              <div className="detail-row">
                <div className="name">Calibrator : </div>
                <div className="value">{MtResult.calibrator}</div>
              </div>
              <div className="detail-row">
                <div className="name">Status Tolerance : </div>
                <div className="value">{MtResult.status_tolerance}</div>
              </div>
              <div className="detail-row">
                <div className="name">Status Workorder : </div>
                <div className="value">{MtResult.status_workorder}</div>
              </div>
              <div className="detail-row">
                <div className="name">Status Accept Workorder : </div>
                <div className="value">{MtResult.status_accept_workorder}</div>
              </div>
              <div className="detail-row">
                <div className="name">Status Approve : </div>
                <div
                  className="value"
                  style={{
                    color:
                      MtResult.status_approve === "APPROVE"
                        ? "#1FD606"
                        : MtResult.status_approve === "REJECT"
                        ? "red"
                        : "#CCCCCC",
                  }}
                >
                  {MtResult.status_approve}
                </div>
              </div>
              <div className="detail-row">
                <div className="name">Concern Person : </div>
                <div className="value">{MtResult.concern_person}</div>
              </div>
              <div className="detail-row">
                <div className="name">Approve Remark : </div>
                <div className="value">{MtResult.approve_remark}</div>
              </div>
              <div className="detail-row">
                <div className="name">Note : </div>
                <div className="value">{MtResult.note}</div>
              </div>
              <div className="detail-row" style={{flexDirection: "column", alignItems: "start"}}>
                <div className="name">Standard Calibrator</div>
                <table className={"table-form"}>
                <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Gas type</th>
                    {/* <th>Input</th>
                    <th>Output</th> */}
                  </tr>
                  {MtResult.form[0].standards.map((standard, i) => {
                    return (
                      <tr key={i}>
                        <td>{standard.standardname}</td>
                        <td>{standard.gastype}</td>
                        {/* <td>{standard.input_value}</td>
                        <td>{standard.output_value}</td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            </div>
          </div>
          <div className="main" style={{ padding: 15, height: "93%" }}>
            {PARAM.formcode === "AZ" ? (
              <Anlyzer
                workorder={MtResult}
                attachequipment={PARAM.attachequipment}
                callback={ onEditSequence }
              />
            ) : null}
            {PARAM.formcode === "DOAZ" ? (
              <DoAnalyzer
                workorder={MtResult}
                attachequipment={PARAM.attachequipment}
                callback={ onEditSequence }
              />
            ) : null}
            {PARAM.formcode === "GASD" ? (
              <GasDetector
                workorder={MtResult}
                attachequipment={PARAM.attachequipment}
                callback={ onEditSequence }
              />
            ) : null}
            {PARAM.formcode === "MD" ? (
              <MetalDetector
                workorder={MtResult}
                attachequipment={PARAM.attachequipment}
                callback={ onEditSequence }
              />
            ) : null}
            {PARAM.formcode === "MDTON" ? (
              <MetalDetectorTon
                workorder={MtResult}
                attachequipment={PARAM.attachequipment}
                callback={ onEditSequence }
              />
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default MaintenanceWorkorderView;
